<div #calendar class="finx-datepicker pointer-events-none">
  @if (selectionMode === 'single') {
    <hlm-date-picker
      [ngStyle]="combinedTextStyles"
      [class]="class"
      [userClass]="class"
      [iconColor]="'inherit'"
      [max]="maxDate"
      [min]="minDate"
      [formControl]="dateStringControl"
      [ngModel]="ngModelValue"
      [formatDate]="formatDateFn"
      (changed)="onSelect($event)"
      (focus)="onFocus()"
      (blur)="onBlur()"
    >
      <div class="labelText labelIdle labelConfig">{{ placeholder }}</div>
    </hlm-date-picker>
  }
  @if (selectionMode === 'range') {
    <hlm-date-range-picker
      [ngStyle]="combinedTextStyles"
      [class]="class"
      [userClass]="class"
      [iconColor]="'inherit'"
      [max]="maxDate"
      [min]="minDate"
      [formControl]="dateStringControl"
      [ngModel]="ngModelValue"
      (changed)="onSelect($event)"
      (focus)="onFocus()"
      (blur)="onBlur()"
    >
      <div class="labelText labelIdle labelConfig">{{ placeholder }}</div>
    </hlm-date-range-picker>
  }
</div>
